import type { FieldValues } from '@zillow/cosmos';
import { PERSON_TYPE } from '../constants/stringConstants';
import PeopleSection from './PeopleSection';

const leasesToCosmosFieldName = {
  tenant0_isEnabled: 'tenant_1_enabled',
  tenant0_firstName: 'tenant_1_first_name',
  tenant0_lastName: 'tenant_1_last_name',
  tenant0_telephoneNumber: 'tenant_1_phone',
  tenant0_email: 'tenant_1_email',
  tenant0_mailingAddress: 'tenant_1_address_for_notice',
  tenant0_applicationId: 'tenant_application_id',
  tenant1_isEnabled: 'tenant_2_enabled',
  tenant1_firstName: 'tenant_2_first_name',
  tenant1_lastName: 'tenant_2_last_name',
  tenant1_telephoneNumber: 'tenant_2_phone',
  tenant1_email: 'tenant_2_email',
  tenant1_mailingAddress: 'tenant_2_address_for_notice',
  tenant2_isEnabled: 'tenant_3_enabled',
  tenant2_firstName: 'tenant_3_first_name',
  tenant2_lastName: 'tenant_3_last_name',
  tenant2_telephoneNumber: 'tenant_3_phone',
  tenant2_email: 'tenant_3_email',
  tenant2_mailingAddress: 'tenant_3_address_for_notice',
  tenant3_isEnabled: 'tenant_4_enabled',
  tenant3_firstName: 'tenant_4_first_name',
  tenant3_lastName: 'tenant_4_last_name',
  tenant3_telephoneNumber: 'tenant_4_phone',
  tenant3_email: 'tenant_4_email',
  tenant3_mailingAddress: 'tenant_4_address_for_notice',
  tenant4_isEnabled: 'tenant_5_enabled',
  tenant4_firstName: 'tenant_5_first_name',
  tenant4_lastName: 'tenant_5_last_name',
  tenant4_telephoneNumber: 'tenant_5_phone',
  tenant4_email: 'tenant_5_email',
  tenant4_mailingAddress: 'tenant_5_address_for_notice',
  tenant5_isEnabled: 'tenant_6_enabled',
  tenant5_firstName: 'tenant_6_first_name',
  tenant5_lastName: 'tenant_6_last_name',
  tenant5_telephoneNumber: 'tenant_6_phone',
  tenant5_email: 'tenant_6_email',
  tenant5_mailingAddress: 'tenant_6_address_for_notice',
  tenant6_isEnabled: 'tenant_7_enabled',
  tenant6_firstName: 'tenant_7_first_name',
  tenant6_lastName: 'tenant_7_last_name',
  tenant6_telephoneNumber: 'tenant_7_phone',
  tenant6_email: 'tenant_7_email',
  tenant6_mailingAddress: 'tenant_7_address_for_notice',
  tenant7_isEnabled: 'tenant_8_enabled',
  tenant7_firstName: 'tenant_8_first_name',
  tenant7_lastName: 'tenant_8_last_name',
  tenant7_telephoneNumber: 'tenant_8_phone',
  tenant7_email: 'tenant_8_email',
  tenant7_mailingAddress: 'tenant_8_address_for_notice',
};

export default class CosmosTenantSection extends PeopleSection {
  constructor(cosmosValues: FieldValues) {
    const fields = [
      {
        fieldName: 'tenant0_isEnabled',
        fieldValue: true,
        dataType: 'boolean',
      },
      {
        fieldName: 'tenant0_firstName',
        fieldValue: '',
        dataType: 'string',
      },
      {
        fieldName: 'tenant0_lastName',
        fieldValue: '',
        dataType: 'string',
      },
      {
        fieldName: 'tenant0_email',
        fieldValue: '',
        dataType: 'string',
      },
      {
        fieldName: 'tenant0_mailingAddress',
        fieldValue: '',
        dataType: 'string',
      },
      {
        fieldName: 'tenant0_telephoneNumber',
        fieldValue: '',
        dataType: 'string',
      },
      {
        fieldName: 'tenant0_applicationId',
        fieldValue: '',
        dataType: 'string',
      },
      {
        fieldName: 'tenant1_isEnabled',
        fieldValue: true,
        dataType: 'boolean',
      },
      {
        fieldName: 'tenant1_firstName',
        fieldValue: '',
        dataType: 'string',
      },
      {
        fieldName: 'tenant1_lastName',
        fieldValue: '',
        dataType: 'string',
      },
      {
        fieldName: 'tenant1_email',
        fieldValue: '',
        dataType: 'string',
      },
      {
        fieldName: 'tenant1_mailingAddress',
        fieldValue: '',
        dataType: 'string',
      },
      {
        fieldName: 'tenant1_telephoneNumber',
        fieldValue: '',
        dataType: 'string',
      },
      {
        fieldName: 'tenant2_isEnabled',
        fieldValue: true,
        dataType: 'boolean',
      },
      {
        fieldName: 'tenant2_firstName',
        fieldValue: '',
        dataType: 'string',
      },
      {
        fieldName: 'tenant2_lastName',
        fieldValue: '',
        dataType: 'string',
      },
      {
        fieldName: 'tenant2_email',
        fieldValue: '',
        dataType: 'string',
      },
      {
        fieldName: 'tenant2_mailingAddress',
        fieldValue: '',
        dataType: 'string',
      },
      {
        fieldName: 'tenant2_telephoneNumber',
        fieldValue: '',
        dataType: 'string',
      },
      {
        fieldName: 'tenant3_isEnabled',
        fieldValue: true,
        dataType: 'boolean',
      },
      {
        fieldName: 'tenant3_firstName',
        fieldValue: '',
        dataType: 'string',
      },
      {
        fieldName: 'tenant3_lastName',
        fieldValue: '',
        dataType: 'string',
      },
      {
        fieldName: 'tenant3_email',
        fieldValue: '',
        dataType: 'string',
      },
      {
        fieldName: 'tenant3_mailingAddress',
        fieldValue: '',
        dataType: 'string',
      },
      {
        fieldName: 'tenant3_telephoneNumber',
        fieldValue: '',
        dataType: 'string',
      },
      {
        fieldName: 'tenant4_isEnabled',
        fieldValue: true,
        dataType: 'boolean',
      },
      {
        fieldName: 'tenant4_firstName',
        fieldValue: '',
        dataType: 'string',
      },
      {
        fieldName: 'tenant4_lastName',
        fieldValue: '',
        dataType: 'string',
      },
      {
        fieldName: 'tenant4_email',
        fieldValue: '',
        dataType: 'string',
      },
      {
        fieldName: 'tenant4_mailingAddress',
        fieldValue: '',
        dataType: 'string',
      },
      {
        fieldName: 'tenant4_telephoneNumber',
        fieldValue: '',
        dataType: 'string',
      },
      {
        fieldName: 'tenant5_isEnabled',
        fieldValue: true,
        dataType: 'boolean',
      },
      {
        fieldName: 'tenant5_firstName',
        fieldValue: '',
        dataType: 'string',
      },
      {
        fieldName: 'tenant5_lastName',
        fieldValue: '',
        dataType: 'string',
      },
      {
        fieldName: 'tenant5_email',
        fieldValue: '',
        dataType: 'string',
      },
      {
        fieldName: 'tenant5_mailingAddress',
        fieldValue: '',
        dataType: 'string',
      },
      {
        fieldName: 'tenant5_telephoneNumber',
        fieldValue: '',
        dataType: 'string',
      },
      {
        fieldName: 'tenant6_isEnabled',
        fieldValue: true,
        dataType: 'boolean',
      },
      {
        fieldName: 'tenant6_firstName',
        fieldValue: '',
        dataType: 'string',
      },
      {
        fieldName: 'tenant6_lastName',
        fieldValue: '',
        dataType: 'string',
      },
      {
        fieldName: 'tenant6_email',
        fieldValue: '',
        dataType: 'string',
      },
      {
        fieldName: 'tenant6_mailingAddress',
        fieldValue: '',
        dataType: 'string',
      },
      {
        fieldName: 'tenant6_telephoneNumber',
        fieldValue: '',
        dataType: 'string',
      },
      {
        fieldName: 'tenant7_isEnabled',
        fieldValue: true,
        dataType: 'boolean',
      },
      {
        fieldName: 'tenant7_firstName',
        fieldValue: '',
        dataType: 'string',
      },
      {
        fieldName: 'tenant7_lastName',
        fieldValue: '',
        dataType: 'string',
      },
      {
        fieldName: 'tenant7_email',
        fieldValue: '',
        dataType: 'string',
      },
      {
        fieldName: 'tenant7_mailingAddress',
        fieldValue: '',
        dataType: 'string',
      },
      {
        fieldName: 'tenant7_telephoneNumber',
        fieldValue: '',
        dataType: 'string',
      },
    ];
    const fieldsWithValue = fields.map((field) => ({
      ...field,
      enteredValue: cosmosValues[leasesToCosmosFieldName[field.fieldName]],
    }));
    super(
      {
        fields: fieldsWithValue,
      },
      PERSON_TYPE.TENANT,
    );
  }

  getCosmosFieldValues(): FieldValues {
    const fieldValues: FieldValues = {};

    Object.keys(leasesToCosmosFieldName).forEach((fieldName) => {
      const field = this.getField(fieldName);
      const cosmosFieldName = leasesToCosmosFieldName[fieldName];

      if (field) {
        fieldValues[cosmosFieldName] = field.enteredValue;
      } else if (fieldName.endsWith('_isEnabled')) {
        fieldValues[cosmosFieldName] = 'false';
      } else {
        fieldValues[cosmosFieldName] = '';
      }
    });

    return fieldValues;
  }
}
